import {useForm} from "react-hook-form";
import ScheduledJobsCalendar from "../components/ScheduledJobsCalendar";

const ScheduledJobsPage: React.FC = () => {
    const { register, reset, getValues, watch} = useForm();
    
    return (
        <div className="container-fluid ptCustom">
            <div className="row justify-content-center">
                <div className="col-lg-10 col-xl-8 my-2">
                    <div className="card shadow-sm rounded-lg">
                        <div className="card-body p-4">
                            <ScheduledJobsCalendar/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScheduledJobsPage